/**
 * Список полей формы OrderEdit для настройки правил доступа (разрешённые/запрещённые поля).
 * Ключи соответствуют полям formData или data() компонента, которые участвуют в редактировании и в getOrderData().
 */
export const ORDER_EDIT_FIELDS = [
  // Заказ, магазин, менеджер
  { id: 'status', label: 'Статус заказа' },
  { id: 'orderType', label: 'Тип заказа' },
  { id: 'orderMethod', label: 'Способ оформления' },
  { id: 'site', label: 'Магазин (сайт)' },
  { id: 'magazin', label: 'Магазин' },
  { id: 'store', label: 'Склад' },
  { id: 'country', label: 'Страна' },
  { id: 'manager', label: 'Менеджер (старый)' },
  { id: 'manager_new', label: 'Менеджер' },
  { id: 'shipmentStore', label: 'Склад отгрузки' },
  { id: 'oneTimeDiscountAmount', label: 'Скидка сумма' },
  { id: 'oneTimeDiscountPercent', label: 'Скидка %' },
  // Клиент
  { id: 'firstName', label: 'Имя' },
  { id: 'lastName', label: 'Фамилия' },
  { id: 'patronymic', label: 'Отчество' },
  { id: 'phone', label: 'Телефон' },
  { id: 'additionalPhone', label: 'Доп. телефон' },
  { id: 'email', label: 'Email' },
  { id: 'email2', label: 'Email 2' },
  // Отгрузка и доставка
  { id: 'shipmentDate', label: 'Дата отгрузки' },
  { id: 'deliveryTypes', label: 'Тип доставки' },
  { id: 'deliveryCost', label: 'Стоимость доставки' },
  { id: 'deliveryDate', label: 'Дата доставки' },
  { id: 'curier', label: 'Курьер' },
  { id: 'deliveryAddress', label: 'Адрес доставки' },
  { id: 'deliverybuilding', label: 'Корпус/строение' },
  { id: 'flat', label: 'Квартира' },
  { id: 'floor', label: 'Этаж' },
  { id: 'block', label: 'Блок' },
  { id: 'housing', label: 'Корпус' },
  { id: 'house', label: 'Дом' },
  { id: 'deliveryregion', label: 'Регион' },
  { id: 'deliverycity', label: 'Город' },
  { id: 'deliverystreet', label: 'Улица' },
  { id: 'timeFrom', label: 'Время доставки с' },
  { id: 'timeTo', label: 'Время доставки до' },
  { id: 'customTime', label: 'Время доставки (своё)' },
  { id: 'weight', label: 'Вес' },
  { id: 'length', label: 'Длина' },
  { id: 'width', label: 'Ширина' },
  { id: 'height', label: 'Высота' },
  { id: 'marssh', label: 'Маршрутный лист курьера' },
  { id: 'deliveryPaidBy', label: 'Оплата доставки' },
  { id: 'installationComplex', label: 'Комплекс установки' },
  { id: 'installationPaidBy', label: 'Оплата установки' },
  // Статус и комментарии
  { id: 'statusComment', label: 'Комментарий к статусу' },
  { id: 'managerComment', label: 'Комментарий менеджера' },
  { id: 'customerComment', label: 'Комментарий клиента' },
  // Контрагент
  { id: 'contragentTypes', label: 'Тип контрагента' },
  { id: 'contragentINN', label: 'ИНН' },
  { id: 'contragentLegalName', label: 'Юр. наименование' },
  { id: 'contragentOKPO', label: 'ОКПО' },
  { id: 'contragentKPP', label: 'КПП' },
  { id: 'contragentOGRNIP', label: 'ОГРНИП' },
  { id: 'contragentLegalAddress', label: 'Юр. адрес' },
  { id: 'contragentOGRN', label: 'ОГРН' },
  { id: 'contragentCertificateNumber', label: 'Номер свидетельства' },
  { id: 'contragentCertificateDate', label: 'Дата свидетельства' },
  { id: 'iuridicheskoe_naimenovanie', label: 'Юридическое наименование' },
  // Доп. поля и счёт
  { id: 'invoiceDate', label: 'Дата счёта (sf_date)' },
  { id: 'sf_num', label: 'Номер счёта (sf_num)' },
  { id: 'data_izmeneniia', label: 'Дата изменения' },
  { id: 'datazakazaobrabotki', label: 'Дата заказа обработки' },
  { id: 'dataSoglasovaniia', label: 'Дата согласования' },
  { id: 'ncorrectBonus', label: 'Некорректный бонус' },
  { id: 'tradeInAmount', label: 'Сумма трейд-ин' },
  { id: 'tradeInAmountNew', label: 'Сумма трейд-ин (нов.)' },
  { id: 'discountCard', label: 'Дисконтная карта' },
  { id: 'selectionLink', label: 'Ссылка на подбор' },
  { id: 'managerComments', label: 'Комментарии менеджера (поле)' },
  { id: 'tegi_dialoga', label: 'Теги диалога (RetailCRM, только просмотр в форме)' },
  { id: 'link_oplata', label: 'Отправить ссылку на оплату' },
  { id: 'shipmentWithoutPayment', label: 'Доставка без оплаты' },
  { id: 'predoplata', label: 'Предоплата' },
  { id: 'vznos', label: 'Сумма первого взноса' },
  { id: 'dostavka_bez_oplaty', label: 'Доставка на наш магазин без оплаты' },
  { id: 'oplacheno_bonusami', label: 'Оплачено бонусами' },
  { id: 'vgvgvgv', label: 'Поле vgvgvgv' },
  // Авто и продавец
  { id: 'carBrand', label: 'Марка авто' },
  { id: 'carModel', label: 'Модель авто' },
  { id: 'carName', label: 'Название авто' },
  { id: 'carYear', label: 'Год авто' },
  { id: 'fuelType', label: 'Тип топлива' },
  { id: 'carBodyType', label: 'Тип кузова' },
  { id: 'registryNumber', label: 'Регистрационный номер' },
  { id: 'seller', label: 'Продавец' },
  { id: 'wrongSelection', label: 'Неверный подбор' },
  { id: 'batteryCapacity', label: 'Ёмкость АКБ' },
  { id: 'batteryCapacityNew', label: 'Ёмкость АКБ (нов.)' },
  // Оценки и проверки (справочники)
  { id: 'ocenka_manageru', label: 'Оценка менеджеру' },
  { id: 'ocenkaprodavcu', label: 'Оценка продавцу' },
  { id: 'ocenochka_kureru', label: 'Оценка курьеру' },
  { id: 'dgh66hhhhhhh', label: 'Приглашение на СТО' },
  { id: 'proverkazakazamenedgero', label: 'Проверка заказа менеджером' },
  { id: 'obzvon_klienta', label: 'Обзвон клиента' },
  { id: 'zvonok_text_bot', label: 'Текст звонка (бот)' },
  // Платежи и товары
  { id: 'payments', label: 'Платежи' },
  { id: 'items', label: 'Товары заказа' },
];
